import { createStore } from "vuex";
import { auth } from "./authModule";
import { planSettings } from "./planSettingsModule";
import { settings } from "./settingsModule";
import { reportData } from "./reportDataModule";
import { packageSettings } from "./packageSettingsModule";
import { containerSettings } from "./containerSettingsModule";
import { orderSettings } from "./orderSettingsModule";
import { shipmentSettings } from "./shipmentSettingsModule";
import { packageFilter } from "./packageFilterModule";
import { loadedPackages } from "./loadedPackagesModule";
import { calculationTime } from "./calculationTimeModule";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    planSettings,
    settings,
    reportData,
    packageSettings,
    containerSettings,
    orderSettings,
    shipmentSettings,
    packageFilter,
    loadedPackages,
    calculationTime,
  },
});
